"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preloadUrl = preloadUrl;
exports.preloadFromCSSVars = preloadFromCSSVars;

/**
 * Preloads the passed url using the browser's Image API
 * @param {string} url - Any asset url which can be preloaded by Image objects
 */
function preloadUrl(url) {
  const i = new Image();
  i.src = url;
}
/**
 * preloadFromCSSVars allows preloading assets defined in CSS variables on the passed element
 * @param {element} - Any DOM element which may have or inherit a CSS variable named
 * '--preload', which is a comma separated list of other CSS variables, with url('...') rules
 * @example
 * ```css
 *  .story {
 *      --preload: 'icon-read-more,share,hero';
 *      --icon-read-more: url('./read-more.svg');
 *      --share: url("share.png");
 *      --hero: url('https://cdn.whatever.com/hero.jpg');
 *
 *      // then later use it as usual with css vars
 *      background-image: var(--hero);
 *  }
 * ```
 *
 * ```js (after importing this function):
 *  const storyElement = document.querySelector('.story');
 *  preloadFromCSSVars(element);
 * ```
 *
 * Or use the React hook in ./preload-effect
 */


function preloadFromCSSVars(element) {
  if (!element) {
    return;
  }

  const styles = getComputedStyle(element);
  const props = styles.getPropertyValue('--preload').replace(/"/g, '').trim().split(',');
  props.forEach(prop => {
    const rule = styles.getPropertyValue("--".concat(prop.trim()));
    const url = rule.replace(/url\(['"]?/, '').replace(/['"]?\)/, '');
    preloadUrl(url);
  });
}